<script lang="ts">
export default {
  name: 'UISearchBar',
}
</script>

<script setup lang="ts">
import { ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export interface Props {
  name: string;
  modelValue?: string | null;
}

export interface Emits {
  (event: 'update:modelValue', searchTerm: string): void;
}

const emit = defineEmits<Emits>();

withDefaults(defineProps<Props>(), {
  modelValue: '',
});

const searchTerm = ref<string>('');

const onXMarkClicked = () => {
  searchTerm.value = '';
  emit('update:modelValue', searchTerm.value);
};

</script>

<template>
  <div class="w-full">
    <div class="relative inline-block w-full">
      <div class="absolute left-3 flex h-full items-center">
          <span class="flex size-6 items-center justify-center rounded-full">
            <FontAwesomeIcon
              size="sm"
              :icon="['fas', 'search']"
              class="text-blue-300"
            />
          </span>
      </div>
      <div 
        v-if="searchTerm.length > 0" 
        data-test-id="xmark"
        class="absolute right-3 flex h-full items-center" 
        @click="onXMarkClicked">
          <span class="flex size-6 items-center justify-center rounded-full">
            <FontAwesomeIcon
              size="sm"
              :icon="['fas', 'times']"
              class="text-gray-700 cursor-pointer"
            />
          </span>
      </div>
      <input
        :id="slugify(name)"
        v-model="searchTerm"
        :name="name"
        placeholder="Zoeken"
        class="block w-full rounded-lg border border-blue-300 p-2 pl-11 pr-10 transition-all
        duration-300 focus:shadow-active disabled:border-gray-100 disabled:bg-gray-100
        disabled:text-gray-700"
        data-test-id="search-bar-input" 
        @keyup="emit('update:modelValue', searchTerm)"
        @paste="emit('update:modelValue', searchTerm)"
      />
    </div>
  </div>
</template>
